const apiBaseUrl = String(process.env.VUE_APP_API_BASE || "/api").replace(/\/+$/, "");

export const buildDpaDocumentUrl = ({ version, locale = "ro" }) => (
  `${apiBaseUrl}/legal/dpa/v${encodeURIComponent(version)}?locale=${encodeURIComponent(locale)}`
);
